import api from "@/shared/services/apiClient";

export interface UserSummary {
  id: string;
  first_name: string;
  last_name: string;
  middle_name?: string;
  user_type: string;
  business_unit: string;
  email: string;
}

export interface RoleDefinition {
  role_name: string;
  module: string;
  access_level: string;
  description?: string;
}

export const accessService = {
  /** Search users (role managers only) */
  getUsers: async (search = ""): Promise<UserSummary[]> => {
    const { data } = await api.get("/access/users", { params: { search } });
    return data.users;
  },

  /** Get all role definition rows from v4.role_definitions */
  getRoleDefinitions: async (): Promise<RoleDefinition[]> => {
    const { data } = await api.get("/access/roles/definitions");
    return data.roles;
  },

  /** Get role_name[] currently assigned to a user */
  getUserRoles: async (userId: string): Promise<string[]> => {
    const { data } = await api.get(`/access/roles/${userId}`);
    return (data.roles as { role_name: string }[]).map((r) => r.role_name);
  },

  /** Atomically replace all roles for a user */
  replaceUserRoles: async (userId: string, roles: string[]): Promise<void> => {
    await api.put(`/access/roles/${userId}`, { roles });
  },
};
